import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  isPaymentMethod?: boolean;
  isDefaultCard: boolean;
}> = ({ isPaymentMethod, isDefaultCard }) => ({
  background: isDefaultCard
    ? (p) => p.palette.success[50]
    : isPaymentMethod
    ? (p) => p.palette.common.white
    : (p) => p.palette.grey[200],
  padding: isPaymentMethod ? (p) => p.spacing(0) : (p) => p.spacing(1.5),
  borderRadius: isPaymentMethod ? (p) => p.spacing(0) : (p) => p.spacing(0.5),
});
